import { PESurveysCardActions, PESurveysCardGetters, PESurveysCardMutations, PESurveysCardState } from './surveys-card'

export const SurveysSectionState = {
  ...PESurveysCardState,
}

export const SurveysSectionActions = {
  ...PESurveysCardActions,
}
export const SurveysSectionGetters = {
  ...PESurveysCardGetters,
}
export const SurveysSectionMutations = {
  ...PESurveysCardMutations,
}
